/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AddressDerivationContext {
    CoreAddressStaking = 'oasis-core/address: staking',
    RuntimeSdkAddressSecp256k1eth = 'oasis-runtime-sdk/address: secp256k1eth',
    RuntimeSdkAddressSr25519 = 'oasis-runtime-sdk/address: sr25519',
    RuntimeSdkAddressMultisig = 'oasis-runtime-sdk/address: multisig',
    RuntimeSdkAddressModule = 'oasis-runtime-sdk/address: module',
    RuntimeSdkAddressRuntime = 'oasis-runtime-sdk/address: runtime'
}

export function AddressDerivationContextFromJSON(json: any): AddressDerivationContext {
    return AddressDerivationContextFromJSONTyped(json, false);
}

export function AddressDerivationContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressDerivationContext {
    return json as AddressDerivationContext;
}

export function AddressDerivationContextToJSON(value?: AddressDerivationContext | null): any {
    return value as any;
}

